import { JobTaskTableFields } from '@/enums';
import { SortOrder } from 'primereact/api';
import { SortState } from '@/hooks/url-search-params/types';

export const DEFAULT_SORT_STATE: SortState = {
    field: JobTaskTableFields.START_TIME,
    order: SortOrder.DESC,
};

export const DEFAULT_PAGINATION_STATE = {
    first: 0,
    rows: 25,
};

export const INITIAL_PAGINATION_DISPLAY_VALUES = {
    first: 0,
    last: 0,
    total: 0,
};
